import React from 'react';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-yellow-500/20 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div>
            <h3 className="text-2xl font-bold mb-4">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-amber-400">
                Gio's
              </span>
              <br />
              <span className="text-white">Car Detailing</span>
            </h3>
            <p className="text-gray-400 mb-4">
              Premium mobile detailing service bringing showroom-quality results to your doorstep.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-lg">Contact Us</h4>
            <div className="space-y-3">
              <a href="tel:4439421539" className="flex items-center gap-3 text-gray-400 hover:text-yellow-400 transition-colors">
                <Phone className="w-5 h-5" />
                <span>(443) 942-1539</span>
              </a>
              <a href="mailto:jasonhines1008@gmail.com" className="flex items-center gap-3 text-gray-400 hover:text-yellow-400 transition-colors break-all">
                <Mail className="w-5 h-5" />
                <span>jasonhines1008@gmail.com</span>
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <MapPin className="w-5 h-5" />
                <span>Mobile Service Available</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-lg">Quick Links</h4>
            <div className="space-y-3">
              <button 
                onClick={() => document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-400 hover:text-yellow-400 transition-colors text-left"
              >
                Services & Pricing
              </button>
              <button 
                onClick={() => document.getElementById('booking-section')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-400 hover:text-yellow-400 transition-colors text-left"
              >
                Book Now
              </button>
              <a 
                href="https://instagram.com/giocar_deatail10" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-yellow-400 transition-colors"
              >
                <Instagram className="w-5 h-5" />
                <span>@giocar_deatail10</span>
              </a>
              <button 
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="block text-gray-400 hover:text-yellow-400 transition-colors text-left"
              >
                Back to Top
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-yellow-500/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Gio's Car Detailing. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Made with precision and care
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
